module.exports = __webpack_public_path__ + "img/guide02.a36118ea.png";